import React from "react";
import { Link } from 'react-router-dom'
import PropTypes from "prop-types";
import classNames from "classnames";
import {
  IconButton,
  Input,
  InputLabel,
  InputAdornment,
  FormControl,
  Button,
  Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import {Visibility, VisibilityOff} from "@material-ui/icons";

// import { sideNavData } from "./tileData";
// import ForgotPassword from "../../containers/ForgotPassword";
import "./LoginForm.css";
import { hasSignedInSinceUpdate } from "../../containers/auth/redux_actions";
const toResetPassword = props => <Link to="/auth/reset-password" {...props} />
const toRegister = props => <Link to="/auth/register" {...props} />
const styles = {};

class Loginform extends React.Component {
  constructor(props) {
    super(props);
  this.state = {
    email: "",
    password: "",
    showPassword: false
  };
  
  this.handleChange = prop => event => {
    this.setState({ [prop]: event.target.value });
  };

  this.handleMouseDownPassword = event => {
    event.preventDefault();
  };

  this.handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  // Submitting via the form lets Enter log in, not just a mouse click.
  this.handleSubmit = event => {
    event.preventDefault();
    let { email, password } = this.state;
    this.props.loginAttempt({
      email,
      password,
      successCallBack: () => {},
      failureCallback: () => {}
    });
  };
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={"auth-form-cntr"}>
        <Typography variant="title" className='box-title' gutterBottom align="center">
          Sign In
        </Typography>
        {hasSignedInSinceUpdate() ? null : (
          <p className="auth-notice">
            <strong>Returning user?</strong> We've updated the platform. If this is your first
            sign-in since the update, please <Link to="/auth/reset-password">set a new password</Link> first.
          </p>
        )}
        <form onSubmit={this.handleSubmit} noValidate>
          <div className={"loginform-cntr"}>
            <FormControl
              fullWidth
              className={classNames(classes.margin, "input-cntr")}
            >
              <InputLabel htmlFor="user-email">Email</InputLabel>
              <Input
                id="user-email"
                name="email"
                type="email"
                autoComplete="email"
                value={this.state.email}
                onChange={this.handleChange("email")}
              />
            </FormControl>
            <FormControl
              fullWidth
              className={classNames(classes.margin, "input-cntr")}
            >
              <InputLabel htmlFor="user-password">Password</InputLabel>
              <Input
                id="user-password"
                name="password"
                autoComplete="current-password"
                type={this.state.showPassword ? "text" : "password"}
                value={this.state.password}
                onChange={this.handleChange("password")}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={this.state.showPassword ? "Hide password" : "Show password"}
                      onClick={this.handleClickShowPassword}
                      onMouseDown={this.handleMouseDownPassword}
                    >
                      {this.state.showPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <Typography
              className="errorMsg"
              variant="caption"
              gutterBottom
              align="center"
              color="secondary"
            >
              {this.props.authMsg}
            </Typography>
            <FormControl
              fullWidth
              className={classNames(classes.margin, "input-cntr")}
            >
              <Button
                variant="raised"
                color="primary"
                className={classNames(classes.button,'box-btn')}
                type="submit"
              >
                <span style={{color:"#FFF"}}>Login</span>
              </Button>
            </FormControl>
            <div className="login-link-cntr">
              <Button
                className={classes.button}
                component={toResetPassword}
              >
                <Typography className="errorMsg" variant="caption" gutterBottom>
                  Forgot Password?
                </Typography>
              </Button> 
              <Button className={classes.button} component={toRegister}>
                <Typography
                  className="errorMsg"
                  variant="caption"
                  gutterBottom
                  color="primary"
                >
                  New User?
                </Typography>
              </Button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

Loginform.propTypes = {
  classes: PropTypes.object.isRequired,
  loginAttempt: PropTypes.func,
  authMsg: PropTypes.string
};

export default withStyles(styles)(Loginform);
